<template>
<!-- eslint-disable max-len -->
<narrative-player :narratives="narratives" :on-complete="onComplete"></narrative-player>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import NarrativePlayer from '../narrative/NarrativePlayer';

export default {
  components: {
    NarrativePlayer
  },
  computed: {
    ...mapGetters([
      'game'
    ]),
    narratives() {
      return this.game && this.game.roleSelectOutroNarratives || [];
    }
  },
  methods: {
    ...mapActions([
      'setRoleSelectOutroViewed'
    ]),
    async onComplete() {
      await this.setRoleSelectOutroViewed();
      this.$router.nextGameState();
    }
  }
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/game/pages/RoleSelectOutro.vue